<template>
    <v-list-item>
      <v-list-item-icon>
        <v-avatar color="#def6ff" size="30" class="icon-box">
          <v-icon small color="#00B3FF">{{ icon }}</v-icon>
        </v-avatar>
      </v-list-item-icon>
      <v-row style="height: 50px;">
        <v-col cols="4" class="detail-label">{{ label }}</v-col>
        <v-col cols="8">
          <v-text-field
            v-model="internalValue"
            :solo="!editMode"
            :outlined="editMode"
            :readonly="!editMode"
            flat
            class="pt-1"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-list-item>
  </template>
  
  <script>
  export default {
    props: {
      icon: String,
      label: String,
      value: String,
      editMode: Boolean,
    },
    computed: {
      internalValue: {
        get() {
          return this.value;
        },
        set(newValue) {
          this.$emit('input', newValue);
        },
      },
    },
  };
  </script>
  
  <style scoped>
  .icon-box {
    border-radius: 30%;
  }
  
  .detail-label {
    font-weight: 500;
    color: black;
  }

  .v-text-field{
    margin-top: -15px;
  }
  .v-text-field--outlined >>> fieldset {
  border-color:#00b3ff63;
}
  </style>
  